// extracted by mini-css-extract-plugin
export var addViewLink = "_h-1";
export var availabilityIcon = "_h-16";
export var availabilitySelectionIcon = "_h-15";
export var backButton = "_h-2";
export var backIcon = "_h-z";
export var conversationCount = "_h-3";
export var dragHandle = "_h-5";
export var dropdown = "_h-e";
export var dropdownIcon = "_h-7";
export var dropdownOption = "_h-6";
export var dropdownTriangle = "_h-d";
export var expand = "_h-f";
export var folder = "_h-i";
export var folderItem = "_h-c";
export var icon = "_h-8";
export var iconRow = "_h-9";
export var image = "_h-a";
export var logo = "_h-b";
export var navContainer = "_h-h";
export var navigationFooter = "_h-g";
export var pageShell = "_h-0";
export var placeholderAvailable = "_h-11";
export var placeholderBox = "_h-14";
export var placeholderBusy = "_h-13";
export var placeholderUnavailable = "_h-12";
export var profile = "_h-k";
export var profileContainer = "_h-m";
export var profileDropdown = "_h-n";
export var profileImage = "_h-l";
export var profileMain = "_h-o";
export var profileSubtitle = "_h-q";
export var profileTitle = "_h-p";
export var reorderIcon = "_h-r";
export var sentLine = "_h-u";
export var settingsHeader = "_h-s";
export var sidenavTextColor = "_h-y";
export var spamLine = "_h-t";
export var subitemWithTag = "_h-4";
export var supportItems = "_h-j";
export var teamText = "_h-10";
export var viewLine = "_h-x";
export var viewLineButton = "_h-w";
export var viewLineButtons = "_h-v";